export default {
  name: 'header',
  props: [
    'authUser',
    'access_token',
  ],
  mounted() {

  },
  data() {
    return {
      company: null,
      samlProviders: [],
      // authUser: this.authUser,
    };
  },
  methods: {
    getSamlLogoutUrl(upn, providers) {
      if (upn.indexOf('@') > -1) {
        const userSuffix = upn.split('@')[1];
        for (let i = 0; i < providers.length; i++) {
          for (let ii = 0; ii < providers[i].suffixes.length; ii++) {
            if (userSuffix === providers[i].suffixes[ii]) {
              return providers[i].logout_url;
            }
          }
        }
      }
    },
    samlLogout() {
      const providers = localStorage.getItem('samlProviders');
      this.samlProviders = providers ? JSON.parse(providers) : null;

      if (this.samlProviders && this.authUser.upn) {
        const logoutUrl = this.getSamlLogoutUrl(this.authUser.upn, this.samlProviders);
        window.open(logoutUrl, '_blank');
      }
    },
    userLogout() {
      this.$router.push({ name: 'logout', query: { logoutPortal: true } });
    },
    getHomeUrl() {
      return `${process.env.START_URL}/`;
    },
    getCompany() {
      const id = this.$route.params.companyId;
      if (!id) return;
      this.$http.get(`companies/${id}/`,
        {
          method: 'GET',
          headers: {
            Authorization: `Token ${this.access_token}`,
          },
        })
        .then((response) => {
          if (response.status !== 200) {
            return;
          }
          this.company = {};
          this.company.id = response.body.id;
          this.company.name = response.body.name;
          this.company.picture = response.body.picture;
        });
    },
  },
  created() {
    this.getCompany();
  },
  computed: {

  },
};



// WEBPACK FOOTER //
// ./src/components/header/header.component.js